















import { Component, Vue, Prop } from 'vue-property-decorator'
import LineForm from './LineForm.vue'
import { namespace } from 'vuex-class'
import { MachineOverview } from '../store/machine'
import { LineGroup, AddMachineToGroup } from '../store/line'

const lineStore = namespace('line')
const machineStore = namespace('machine')

@Component({ components: { LineForm } })
export default class EditLine extends Vue {
  dialog = false
  @lineStore.Action addMachineToGroup!: (
    sensor: AddMachineToGroup
  ) => Promise<LineGroup>
  @machineStore.Action getAll!: () => void
  @machineStore.Getter machines!: MachineOverview[]
  @Prop() lineGroup!: LineGroup
  get machineWithNoLineGroup() {
    return this.machines.filter(m => m.lineGroup === '')
  }
  created() {
    this.getAll()
  }
  async edit(data: AddMachineToGroup) {
    await this.addMachineToGroup(data)
    await this.getAll()
    this.dialog = false
  }
}
